{
  "Appointment": "Programare",
  "snapshotFields": {
    "status": "Stare",
    "subject": "Subiect",
    "startTime": "Ora început",
    "endTime": "Ora sfârșit",
    "isAllDay": "Toată ziua",
    "isBlock": "Interval blocat",
    "startTimezone": "Fus orar început",
    "endTimezone": "Fus orar sfârșit",
    "description": "Descriere",
    "isReadOnly": "Doar citire",
    "recurrence": "Recurență",
    "cancelationReason": "Motiv anulare",
    "cancelationReasonDetails": "Detalii anulare",
    "cancellationReason": "Motiv anulare",
    "canceledAt": "Anulată la",
    "canceledBy": "Anulată de",
    "rescheduledFromAppointment": "Reprogramată din (ID programare)",
    "rescheduledToAppointment": "Reprogramată în (ID programare)",
    "department": "Departament",
    "location": "Locație",
    "company": "Firmă",
    "patient": "Pacient",
    "employee": "Cadru medical",
    "partnerEmployee": "Medic trimițător",
    "patientSheetType": "Tip fișă pacient",
    "patientSheet": "Fișă pacient",
    "competency": "Competență",
    "competencies": "Competențe",
    "rooms": "Săli",
    "equipments": "Echipamente",
    "source": "Sursă",
    "notifications": "Notificări",
    "sms": "SMS",
    "isActive": "Activ",
    "confirmationMessage": "Mesaj de confirmare",
    "reminderMessage": "Mesaj de reamintire",
    "reminderQueueIds": "Coadă reamintiri",
    "emailIds": "Emailuri",
    "smsIds": "Mesaje SMS",
    "messageBody": "Mesaj",
    "firstName": "Prenume",
    "lastName": "Nume",
    "professionalTitle": "Titlu profesional",
    "phone": "Telefon",
    "phonePrefix": "Prefix telefon",
    "email": "Email",
    "idNumber": "CNP",
    "gender": "Gen",
    "parafaCode": "Cod parafă",
    "name": "Nume",
    "code": "Cod",
    "module": "Modul",
    "kind": "Tip",
    "reference": "Referință",
    "details": "Detalii",
    "rule": "Regulă",
    "exception": "Excepție",
    "first": "Prima apariție"
  }
}
